<template>
  <div>
    <portal-target name="pinPortal1"></portal-target>
    <!-- <div class="radioBox" v-if="enablePinOK !== true"> -->
    <div class="radioBox" v-if="showEnterPhone === true">
      <b-form-group
        class="gHead"
        :style="{ fontSize: fonts.font16 + 'px' }"
        v-bind:label="title">
        <div class="rGroup">
          <b-radio-group v-model="how">
            <div>
              <b-radio
                value="Text"
                :style="{ fontSize: fonts.font14 + 'px'}"
              >Text to Specified Mobile Number</b-radio>
            </div>
            <div>
              <b-radio
                value="Call"
                :style="{ fontSize: fonts.font14 + 'px'}"
              >Voice Call to Home or Mobile Phone</b-radio>
            </div>
          </b-radio-group>
        </div>
        <div class="warn" :style="{ fontSize: fonts.font16 + 'px'}">
          {{this.exist}}
        </div>
        <div style="height: 5px;"></div>
        <div>
          <b-form-input
            :name="fonRand"
            :id="fonRand"
            v-model="phone"
            class="recPin"
            ref="inpFon"
            v-on:focus.native="inputPhoneGotFocus"
            aria-label="Enter authorization phone number"
            placeholder="Enter phone number"
          ></b-form-input>
        </div>
        <b-button-group>
          <b-button class="btnGreen"
                    @click="submitRequest">
            Request Pin
          </b-button>
          <b-button class="btnRed"
                    @click="cancel">
            Cancel
          </b-button>
          <b-button class="btnBlue"
                    @click="help">
            Help
          </b-button>
        </b-button-group>
      </b-form-group>
    </div>
    <portal-target name="pinPortal2"></portal-target>
    <!-- <div class="recoveryBox" v-if="enablePinOK === true"> -->
    <div class="recoveryBox">
      <b-form-group
        class="gHead"
        :style="{ fontSize: fonts.font16 + 'px' }"
        label="Once you receive the PIN">
        <div class="xLabel">on your phone, enter it here</div>
        <div>
          <b-form-input
            :name="pinRand"
            v-model="pin"
            class="recPin"
            ref="inpPin"
            v-on:focus.native="enterPinGotFocus"
            aria-label="Enter Authorization PIN"
            placeholder="6 digit Authorization PIN"
          ></b-form-input>
        </div>
        <div v-if="this.o2Len > 0" class="rGroup">
          <b-radio-group v-model="access">
            <div>
              <b-radio
                value="pinOpt1"
                :style="{ fontSize: fonts.font14 + 'px'}"
              >{{this.opt1}}</b-radio>
            </div>
            <div>
              <b-radio
                value="pinOpt2"
                :style="{ fontSize: fonts.font14 + 'px'}"
              >{{this.opt2}}</b-radio>
            </div>
            <div v-if="this.o3Len > 0">
              <b-radio
                value="pinOpt3"
                :style="{ fontSize: fonts.font14 + 'px'}"
              >{{this.opt3}}</b-radio>
            </div>
            <div v-if="this.o4Len > 0">
              <b-radio
                value="pinOpt4"
                :style="{ fontSize: fonts.font14 + 'px'}"
              >{{this.opt4}}</b-radio>
            </div>
          </b-radio-group>
        </div>

        <div v-if="optType === 'auth'">
          <div style="height: 10px;"></div>
          <div v-if="!showAuthHelp">
            <span class="setupLink"
                  @click="toggleAuthHelp">
              Click for Authorization Help
            </span>
          </div>
          <div v-if="showAuthHelp">
            <div class="setupLink"
                  @click="toggleAuthHelp">
              Hide Authorization Help
            </div>
            <p style="font-size: 14px;">
              Select One-Time if on a public computer.<br />
              Select Permanent to remember this device.<br />
              If Permanent is forgetting the device, check<br />
              to make sure no program is deleting cookies.<br />
              <span style="color: red">
              If you are browsing in Private Mode, the<br />
              permanent Access token can't be stored.
              </span>
            </p>
          </div>
          <div style="height: 10px;"></div>
        </div>
        <!-- -->
        <div v-if="this.opt1 === 'PWD'">
          <div>
            <div style="height: 10px;"></div>
            <span>New Password for Account</span>
            <!-- <div>{{newPassword}} ({{myPwValid}})</div> -->
            <zPass></zPass>
          </div>
          <div style="height: 5px;"></div>
          <b-form-checkbox
                           v-model="extendedPass"
          >Extended Password
          </b-form-checkbox>
          <div style="height: 5px;"></div>
          <div class="pwHelpStyle" @click="pwdHelp">Password Help</div>
          <div style="height: 5px;"></div>
          <div class="pwHelpStyle" @click="extHelp">Extended PW Help</div>
          <div style="height: 5px;"></div>
        </div>

        <!-- -->
        <div v-if="this.opt1 === 'XOM'">
          <div>
            <div style="height: 10px;"></div>
            <!-- <div v-if="!showOtherHelp"
                 class="setupLink"
                 @click="otherPinHelp">
              Show Hints
            </div>
            <div v-if="showOtherHelp"
                 class="setupLink"
                 @click="otherPinHelp">
              Hide Hints
            </div>
            <div style="height: 10px;"></div> -->
            <span>Destination Account Number</span>
            <p v-if="showOtherHelp" class="xHint"
               :style="{ fontSize: fonts.font12 + 'px', color: 'blue' }">
              Account you are transferring money to:</p>
            <b-form-input :name="xAcctRand"
                          :id="xAcctRand"
                          ref="destAcct"
                          autocomplete="nope"
                          autocorrect="off"
                          autocapitalize="off"
                          spellcheck="false"
                          class="acctInput"
                          aria-label="Destination Account Number"
                          type="text"
                          v-model="otherAccount"
                          required
                          placeholder="Destination Account">
            </b-form-input>
            <div style="height: 10px;"></div>
            <div v-if="!showOtherHelp" class="xHint"
                 :style="{ fontSize: fonts.font12 + 'px', color: 'blue' }">
              <b v-if="!showPinSetupHelp">
                This is NOT the PIN from the OLD Home-Bank</b>
              <span v-if="!showPinSetupHelp"
                class="setupLink"
                @click="setupPinHelp">
                Show how to create destination PIN
              </span>
              <span v-if="showPinSetupHelp"
                    class="setupLink"
                    @click="setupPinHelp">
                Hide pin setup Help
              </span>
              <div style="height: 10px;"></div>
            </div>
            <p v-if="showPinSetupHelp" class="xHint"
               :style="{ fontSize: fonts.font12 + 'px' }">
              <pin-setup-help></pin-setup-help> <!-- [172] -->
              <b style="color: red;">
                See help on main transfer page for details
              </b>
            </p>
            <span>Destination Authorization Pin</span>
            <p v-if="showOtherHelp" class="xHint"
               :style="{ fontSize: fonts.font12 + 'px', color: 'blue' }">
              Enter the PIN the OTHER member gave you: <br />
              (This is not the old home bank pin)</p>
            <b-form-input :name="xPinRand"
                          :id="xPinRand"
                          ref="destPin"
                          autocomplete="nope"
                          autocorrect="off"
                          autocapitalize="off"
                          spellcheck="false"
                          class="acctInput"
                          aria-label="Destination Authorization Pin"
                          type="text"
                          v-model="otherAccountPin"
                          required
                          placeholder="4 Digit Destination Auth Pin">
            </b-form-input>
            <div v-if="showOtherHelp"
              style="height: 5px;"></div>
            <p v-if="showOtherHelp" class="xHint"
               :style="{ fontSize: fonts.font12 + 'px', color: 'blue' }">
              NOTE: If this destination account is a secondary account
              or if you transfer money to this account on a regular basis,
              the credit union can set this account up as a sub-account
              on your main account so it will show on the destination
              account drop-down list, and you won't need to validate
              a PIN on your phone to transfer to it.<br />
              See HELP on the main transfer screen for more information.
            </p>

          </div>
          <div style="height: 5px;"></div>
        </div>

        <b-button-group>
          <b-button class="btnGreen"
                    @click="submitPin"
                    :class="{disabled: !enablePinOK}">
            OK
          </b-button>
          <b-button class="btnRed"
                    @click="cancel">
            Cancel
          </b-button>
        </b-button-group>
      </b-form-group>
    </div>
    <!-- <portal-target name="pinPortal2"></portal-target> -->
    <div style="height: 10px;"></div>
    <portal to="pinPortal1">
      <div class="helpBox" v-if="showHelp === true">
        <div class="helpBoxLeft" :style="{ fontSize: fonts.font14 + 'px'}">
          <div v-html="pinHelpText"></div>
        </div>
        <div>
          <b-button class="btnSmallGreen"
                    @click="closeHelp">
            Close
          </b-button>
        </div>
      </div>
    </portal>
    <portal to="pinPortal2">
      <div v-if="showExtHelp === true" class="helpBox">
        <div class="helpBoxLeft" :style="{ fontSize: fonts.font14 + 'px'}">
          <div class="helpHeader">Extended Password Help</div>
          <div v-if="extendedPass === true" v-html="extRecommendedText"></div>
          <div>
            {{ditchOldRecommendedText}}
          </div>
        </div>
        <b-button class="btnSmallGreen"
                  @click="closeExtHelp">
          Close
        </b-button>
      </div>
    </portal>
    <portal to="pinPortal2">
      <div v-if="showPwdHelp === true" class="helpBox">
        <div class="helpBoxLeft" :style="{ fontSize: fonts.font14 + 'px'}">
          <div class="helpHeader">Password Help</div>
          <div v-html="pwdHelpText"></div>
          <div v-html="ditchOldRecommendedText"></div>
        </div>
        <b-button class="btnSmallGreen"
                  @click="closePwdHelp">
          Close
        </b-button>
      </div>
    </portal>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';
import zPass from './z-pass';
import pinSetupHelp from './pinSetupHelp';

export default {
  components: {
    zPass,
    pinSetupHelp,
  },
  name: 'sendPin',
  props: ['acct', 'optType', 'type', 'opt1', 'opt2', 'opt3', 'opt4'],
  data() {
    return {
      exist: 'Phone number must already exist on account',
      how: 'Text',
      access: 'pinOpt1',
      phone: '',
      pin: '',
      pwRand: '',
      fonRand: '',
      pinRand: '',
      showHelp: false,
      showExtHelp: false,
      showPwdHelp: false,
      showEnterPhone: true,
      extendedPass: true,
      hidePass: false,
      passStyle: '',
      myPwValid: '',
      otherAccount: '',
      otherAccountPin: '',
      xAcctRand: '',
      xPinRand: '',
      vPinRand: '',
      hPinRand: '',
      doFocusInpPin: false,
      otVisible: false,
      otHidden: false,
      iPinVisible: '',
      iPinHidden: '',
      showOtherHelp: false,
      showPinHelp: false,
      showPinSetupHelp: false,
      showAuthHelp: false,
    };
  },
  watch: {
    myTenthSecond() {
      this.intervalTenthSecond();
    },
    extendedPass() {
      this.checkExtendedPW();
    },
    hidePass() {
      this.onHidePwChange();
    },
    pwValid() {
      this.setMyPwValid();
    },
    requestPhone() {
      if (this.requestPhone > 0) {
        // utl.diag(`sendPin:watch:requestPhone called - ${this.requestPhone}`);
        this.phone = '';
        this.pin = '';
        this.showEnterPhone = true;
        this.$refs.inpFon.focus();
        this.$store.commit('setResetPinRequester', false);
      } else {
        // utl.diag('sendPin:watch:requestPhone called - 0');
      }
    },
    enablePinOK() {
      this.showEnterPhone = !this.enablePinOK;
      if (this.enablePinOK === true) {
        // utl.diag('enablePinOK became true');
        this.doFocusInpPin = true;
      }
    },
  },
  computed: {
    pw1Rand() {
      return this.$store.getters.getPw1Rand;
    },
    myTenthSecond() {
      return this.$store.getters.getMyTenth;
    },
    requestPhone() {
      return this.$store.getters.getResetPinRequester;
    },
    newPassword() {
      return this.$store.getters.getNewPassword;
    },
    pwValid() {
      return this.$store.getters.getPwValid;
    },
    enablePinOK() {
      return this.$store.getters.getEnablePinOK;
    },
    pwChangeOption() {
      return this.$store.getters.getPwChangeOption;
    },
    pinHelpText() {
      return this.$store.getters.getPinHelp;
    },
    pwdHelpText() {
      return this.$store.getters.getPwdHelp;
    },
    extRecommendedText() {
      return this.$store.getters.getExtRecommended;
    },
    ditchOldRecommendedText() {
      return this.$store.getters.getDitchOldRecommended;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    title() {
      return `Request ${this.type} Pin`;
    },
    o2Len() {
      return this.opt2.length;
    },
    o3Len() {
      return this.opt3.length;
    },
    o4Len() {
      return this.opt4.length;
    },
    navVer() {
      return this.$store.getters.getNavVer;
    },
    fonValid() {
      let result = true;
      if (this.phone == null) {
        result = false;
      } else {
        // eslint-disable-next-line
        if (this.phone.length < 10) { // [170] was != 10
          result = false;
        }
      }
      return result;
    },
    pinValid() {
      return (this.pin.length === 6);
    },
    showBannerFlag() {
      return this.$store.getters.getShowBanner;
    },
    banners() {
      return this.$store.getters.getBanners;
    },
  },
  methods: {
    toggleAuthHelp() {
      this.showAuthHelp = !this.showAuthHelp;
    },
    setupPinHelp() {
      this.showPinSetupHelp = !this.showPinSetupHelp;
    },
    otherPinHelp() {
      this.showOtherHelp = !this.showOtherHelp;
    },
    pinHelp() {
      this.showPinHelp = !this.showPinHelp;
    },
    intervalTenthSecond() {
      if (this.doFocusInpPin === true) {
        this.doFocusInpPin = false;
        this.$refs.inpPin.$el.focus();
      }
    },
    setMyPwValid() {
      if (this.pwValid === true) {
        this.myPwValid = 'true';
      } else {
        this.myPwValid = 'false';
      }
    },
    pwdHelp() {
      this.showPwdHelp = true;
      let y = 0;
      if ((this.banners.count > 0) && (this.showBannerFlag === true)) { y = 1; }
      utl.scrollToMiddle(y);
    },
    closeHelp() {
      this.showHelp = false;
    },
    closeExtHelp() {
      this.showExtHelp = false;
    },
    closePwdHelp() {
      this.showPwdHelp = false;
    },
    onExtPwChange() {
      this.showExtHelp = true;
    },
    extHelp() {
      this.showExtHelp = true;
      let y = 0;
      if ((this.banners.count > 0) && (this.showBannerFlag === true)) { y = 1; }
      utl.scrollToMiddle(y);
    },
    pwGotFocus() {
      // do something
    },
    onBlurPassword() {
      // do something
    },
    onHidePwChange() {
      if (this.hidePass === true) {
        this.passStyle = 'text-security:disc; -webkit-text-security:disc;';
      } else {
        this.passStyle = '';
      }
    },
    submitRequest() {
      const savePhone = this.phone;
      this.phone = utl.fmtPhone(this.phone);
      if (this.phone === 'invalid phone#') {
        this.showAlert('Please enter a valid phone number');
        this.phone = savePhone;
        this.$refs.inpFon.focus();
        return;
      }
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = this.acct;
      cuInfo.type = this.how;
      cuInfo.phone = this.phone;
      cuInfo.navVer = this.navVer;
      this.$store.commit('setValidatePhone', this.phone); // Save so can display in Error msg
      // utl.diag(cuInfo);
      this.wsSend('c4RequestPin', cuInfo);
      // this.$refs.inpPin.$el.focus();
      this.showConfirm('Sending request to server...');
    },
    cancel() { // Go Back
      window.history.back();
    },
    help() {
      this.showHelp = !this.showHelp;
    },
    inputPhoneGotFocus() {
      this.hideConfirm();
      this.hideAlert();
      if (this.requestPhone > 0) {
        this.showAlert(utl.getServerStatus(this.requestPhone));
      }
    },
    enterPinGotFocus() {
      this.hideAlert();
      if (this.requestPhone > 0) {
        this.showAlert(utl.getServerStatus(this.requestPhone));
      }
    },
    hideConfirm() {
      this.$store.commit('setConfirmShow', false);
    },
    showConfirm(message) {
      this.$store.commit('setConfirmMessage', message);
    },
    hideAlert() {
      this.$store.commit('setAlertShow', false);
    },
    showAlert(message) {
      this.$store.commit('setAlertMessage', message);
    },
    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      this.$store.commit('sendObjToServer', data);
    },
    submitPin() {
      if (this.enablePinOK === false) {
        // this.showAlert('No valid PIN request Sent'); // This gets instantly cleared
        this.$refs.inpFon.focus(); // Warning - Also clears alerts
        return; // OK not enabled
      }
      this.hideAlert();
      this.hideConfirm();
      const savePin = this.pin;
      this.pin = utl.fmtPin(this.pin);
      if (this.pin === 'invalid pin') {
        this.showAlert('Please enter a valid PIN number');
        this.pin = savePin;
        // this.$refs.inpPin.$el.focus();
        return;
      }
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = this.acct;
      cuInfo.pin = this.pin;
      cuInfo.optType = this.optType;
      cuInfo.myOpt = this.access;
      cuInfo.navVer = this.navVer;
      if (this.optType === 'auth') {
        if (this.access === 'pinOpt1') this.$store.commit('setOTP', true); // One Time Pin
        if (this.access === 'pinOpt2') this.$store.commit('setOTP', false); // Permanent
        this.wsSend('c4ValidatePin', cuInfo);
      }
      if (this.optType === 'unAuth') {
        this.wsSend('c4ValidatePin', cuInfo);
      }
      if (this.optType === 'pwChange') {
        cuInfo.option = 1; // Change Password
        cuInfo.newPass = this.newPassword;
        cuInfo.extPass = this.extendedPass;
        if (this.pwValid !== true) {
          this.showAlert('Password requirements not met');
          this.$store.commit('setFocusChangePW', true);
          return;
        }
        this.wsSend('c4ChangePassword', cuInfo);
      }
      if (this.optType === 'unlock') {
        cuInfo.option = 2; // Unlock Account
        cuInfo.newPass = 'unlock Account';
        cuInfo.extPass = '1';
        this.wsSend('c4ChangePassword', cuInfo);
      }
      if (this.optType === 'xfOther') {
        cuInfo.otherAcct = this.otherAccount;
        cuInfo.otherPin = this.otherAccountPin;
        if (this.otherAccount.length === 0) {
          this.showAlert('Invalid Destination Account');
          this.$refs.destAcct.$el.focus();
          return;
        }
        if (this.otherAccountPin.length === 0) {
          this.showAlert('Invalid Destination Pin');
          this.$refs.destPin.$el.focus();
          return;
        }
        this.wsSend('c4RequestOtherAccount', cuInfo);
        // window.history.back(); // Go back to xfer screen and wait for response
      }
      if (this.optType === 'setupPins') {
        /*
        cuInfo.otVisible = this.otVisible; // One Time Visible (true/false)
        cuInfo.iPinVisible = this.iPinVisible; // Pin for visible balances
        cuInfo.otHidden = this.otHidden; // One Time Hidden (true/false)
        cuInfo.iPinHidden = this.iPinHidden; // Pin for hidden balances
        */
        cuInfo.option = 'auth';
        cuInfo.otVisible = false; // One Time Hidden (true/false)
        cuInfo.iPinVisible = 0; // Pin for visible balances
        cuInfo.otHidden = false; // One Time Hidden (true/false)
        cuInfo.iPinHidden = 0; // Pin for hidden balances
        this.wsSend('c4SetXferPins', cuInfo);
      }
      // this.showConfirm(`Checking for valid pin for account ${this.acct}.`);
    },
    diag(message) {
      this.$store.commit('showDiag', message);
    },
    writeDiag(message) {
      this.$store.commit('putDiag', message);
    },
    checkExtendedPW() {
      this.$store.commit('setExtendedPwStatus', this.extendedPass);
    },
    handleKeyStroke(event) {
      let keyCode = event.keyCode;
      const e1 = document.activeElement;
      // utl.diag(`sentPin-keyPressed: ${event.keyCode}`);
      if (keyCode === 13) { // Enter Pressed
        // utl.diag('Enter Pressed');
        // utl.diag(`e1.name="${e1.name}"`);
        keyCode = 0;
        event.preventDefault();
        event.stopPropagation(true);
        if ((e1.name === this.fonRand) && (this.fonValid === true)) {
          this.submitRequest();
        }
        if ((e1.name === this.pinRand) && (this.pinValid === true)) {
          this.$store.commit('setFocusChangePW', true);
        }
        if ((e1.name === this.pw1Rand) && (this.pwValid === true)) {
          // utl.diag('SubmitPin()');
          this.submitPin();
        }
      }
      if (e1.name === this.fonRand) {
        // Ignore non-numeric keys
        if ((keyCode > 0) && ((keyCode < 48) || (keyCode > 57))) {
          event.preventDefault(true);
          event.stopPropagation(true);
        }
      }
    },
  },
  mounted() {
    this.$store.commit('setEnablePinOK', false);
    const myDate = +new Date();
    this.fonRand = `fon${myDate}`;
    this.pwRand = `pw${myDate}`;
    this.pinRand = `pin${myDate}`;
    this.xAcctRand = `xar${myDate}`;
    this.xPinRand = `xpr${myDate}`;
    this.vPinRand = `vis${myDate}`;
    this.hPinRand = `hid${myDate}`;

    // utl.diag('sendPin - Mounted()');
    this.exist = `Phone number must already exist on account ${this.acct}`;
    this.setMyPwValid();
    this.$refs.inpFon.focus();
  },
  created() {
    window.addEventListener('keypress', this.handleKeyStroke);
  },
  destroyed() {
    window.removeEventListener('keypress', this.handleKeyStroke);
  },
};
</script>

<style scoped>
  .radioBox {
    display: inline-block;
    border: solid 2px black;
    padding: 10px 10px 10px 10px; /* top, right, bottom, left*/
    max-width: 350px;
  }
  .rGroup {
    /* border: solid 2px black;*/
    padding-left: 4px;
    text-align: left;
  }
  .gHead {
    font-weight: bold;
    color: black;
  }
  .recoveryBox {
    display: inline-block;
    border: solid 2px black;
    padding: 10px 10px 10px 10px; /* top, right, bottom, left*/
    margin-top: 10px;
    max-width: 350px;
  }
  .helpHeader {
    font-weight: bold;
    font-size: 32px;
    margin: auto;
    color: blue;
    text-align: center;
  }
  .helpBoxTitle {
    color: blue;
    font-size: 24px;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }
  .helpBox {
    border: solid 4px red;
    background-color: white;
    padding: 4px 10px 4px 10px; /* top, right, bottom, left*/
  }
  .helpBoxLeft {
    text-align: left;
    background-color: white;
    padding: 4px 10px 4px 10px; /* top, right, bottom, left*/
  }

  .recPin {
    position: relative;
    display: inline-flex;
    horiz-align: center;
    width: 200px;
  }
  .inpPwd {
    position: relative;
    display: inline-flex;
    horiz-align: center;
    width: 200px;
    margin-top: 4px;
  }
  .btnGreen {
    background-color: lime;
    color: black;
    font-weight: bold;
    top: 10px;
    margin-left: 6px;
    margin-right: 6px;
  }
  .btnSmallGreen {
    background-color: lime;
    color: black;
    font-size: 10px;
    font-weight: bold;
    top: 10px;
    margin-left: 6px;
    margin-right: 6px;
  }
  .btnRed {
    background-color: red;
    color: black;
    font-weight: bold;
    top: 10px;
    margin-left: 6px;
    margin-right: 6px;
  }
  .btnBlue {
    background-color: cyan;
    color: black;
    font-weight: bold;
    top: 10px;
    margin-left: 6px;
    margin-right: 6px;
  }
  .warn {
    color: red;
    font-weight: bold;
    background-color: white;
    border: solid 1px red;
  }
  .pwHelpStyle {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }
  .acctInput {
  }
  .xLabel {
    position: relative;
    top: -8px;
    padding-top: 0px;
  }
  .xHint {
    position: relative;
    padding-top: 0px;
    padding-bottom: 0px;
    margin: 0px;
  }
  .setupLink {
    position: relative;
    /* top: 6px;
    padding-top: 4px;
    height: 30px;
    padding-bottom: 6px; */
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/sendPin.vue